(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("smsBalanceService", SMSBalanceService);


    function SMSBalanceService($q) {
        var self = this;

        self.USAGE_TYPES = {
            'SOCIAL_REFERRAL': 'SOCIAL_REFERRAL',
        };

        self.getBalance = function (brandId, usageCode) {
            var defer = $q.defer();
            NotificationCenterAPIV2.getSMSBalance(brandId).then(function (resp) {
                var sms_balances = resp && resp.sms_balances, sms_balance;
                if (sms_balances && sms_balances.length > 0) {
                    for (var i = 0; i < sms_balances.length; i++) {
                        sms_balance = sms_balances[i];
                        if (sms_balance.usage_type === usageCode && self.USAGE_TYPES[usageCode]) {
                            defer.resolve(self.formatSMSBalance(sms_balance));
                        }
                    }
                }
                defer.resolve(false);
            }, function(){
                defer.resolve(false);
            });

            return defer.promise;
        };

        self.formatSMSBalance = function(sms_balance){
            return {
                total: sms_balance.monthly_balance,
                consumed: sms_balance.monthly_balance - sms_balance.usage.remaining_balance,
                remaining: sms_balance.usage.remaining_balance
            };
        };
    }
    SMSBalanceService.$inject = ['$q',];

})();